module.exports = __webpack_public_path__ + "static/media/INFORMATIVA PRIVACY.36d9ad3a.pdf";